import { withAuthenticationRequired } from '@tom-ui/utils'
import { Box } from '@mui/material'
import { useOperationsStore } from '@operations/AppProvider'
import CraneOperatorListViewContainer from '@operations/features/craneOperator/containers/CraneOperatorListViewContainer'
import ListViewLegendHeaderContainer from '@operations/features/craneOperator/containers/ListViewLegendHeaderContainer'
import { useMinimalsTheme } from '@tom-ui/ui'

import { useTranslate } from '@tolgee/react'
import { FC, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useParams } from 'react-router'

const CraneOperatorListView: FC = withAuthenticationRequired(() => {
  const theme = useMinimalsTheme()
  const { craneOperatorUIStore } = useOperationsStore()
  const { vesselVisitId, equipmentId } = useParams()

  const { t } = useTranslate()

  useEffect(() => {
    const loadLandingPageData = async () => {
      await craneOperatorUIStore.loadVesselGeometry()
    }

    //only load if list view did not load before
    if (
      craneOperatorUIStore.selectedVesselVisitId !== Number(vesselVisitId) ||
      craneOperatorUIStore.selectedEquipmentId !== Number(equipmentId)
    ) {
      craneOperatorUIStore.selectedVesselVisitId = Number(vesselVisitId)
      craneOperatorUIStore.selectedEquipmentId = Number(equipmentId)
      loadLandingPageData()
    }
  }, [craneOperatorUIStore, equipmentId, vesselVisitId])

  return (
    <>
      <Helmet>
        <title>{t('sts', 'STS')}</title>
      </Helmet>
      <ListViewLegendHeaderContainer uiStore={craneOperatorUIStore} />
      <Box padding={theme.spacing(2)}>
        <CraneOperatorListViewContainer uiStore={craneOperatorUIStore} />
      </Box>
    </>
  )
})

export default CraneOperatorListView
